function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgMarca = function SvgMarca(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M28.083 17.412l-7.5-1.623-1.945 7.635a.5.5 0 01-.969-.246l1.9-7.46H12.43l1.9 7.46a.5.5 0 01-.968.246l-1.942-7.62-4.19 1.062a.5.5 0 11-.247-.97l4.21-1.067a.5.5 0 01.016-.11l.707-2.697a.5.5 0 01.968.254l-.641 2.442h7.53L18.74 9.56a.499.499 0 01-.003-.175h-7.293a1 1 0 00-.707.293L4.12 16.293a1 1 0 000 1.414L15.293 28.88a1 1 0 001.414 0L27.88 17.707a.998.998 0 00.204-.295zm-.145-1.054a1.013 1.013 0 00-.06-.065l-6.615-6.615a1 1 0 00-.707-.293h-.83l1.072 5.363-.002.064 7.142 1.546zM11.444 8.385h9.112a2 2 0 011.414.585l6.616 6.616a2 2 0 010 2.828L17.414 29.586a2 2 0 01-2.828 0L3.414 18.414a2 2 0 010-2.828L10.03 8.97a2 2 0 011.414-.585zm-4.467-5.15a.5.5 0 11.866-.5l1.29 2.236a.5.5 0 01-.865.5L6.977 3.235zM2.924 6.783a.5.5 0 11.5-.866l2.252 1.3a.5.5 0 11-.5.866l-2.252-1.3zm11.459-3.659l-1.3 2.252a.5.5 0 11-.866-.5l1.3-2.252a.5.5 0 11.866.5z"
  }));
};

SvgMarca.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgMarca.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgMarca;